/**
 * SEO routes для store домена
 * Только основные маршруты, которые должны быть доступны на csgofast.store
 */
export const seoRoutesStore: string[] = [
  /*[[START-PARSE]]*/
  '/',
  '/welcome',
  '/betting',
  '/pickem',
  /*[[END-PARSE]]*/
];
